module.exports = __webpack_public_path__ + "fonts/NunitoSans_7pt-BlackItalic.1b22ba0e.ttf";